// hooks/useCartPrefill.js
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { normalizeCartItems, itemsKey } from "../utils/cartHelpers";

export const useCartPrefill = ({
  loading,
  companyId,
  myId,
  selectedRequest,
  cartItemsArray,
  cartItemsKey,
  cartReplace,
  onFormUpdate,
}) => {
  const location = useLocation();
  const [cartPrefillHandled, setCartPrefillHandled] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (cartPrefillHandled) return;
    if (!companyId || !myId) return;

    const params = new URLSearchParams(location.search || "");
    const requestIdParam = params.get("requestId");
    const accountIdParam = params.get("accountId");
    if (requestIdParam || accountIdParam) return;
    if (selectedRequest) return;

    // 1) navigation state wins
    let incoming =
      Array.isArray(location?.state?.cartItems) && location.state.cartItems.length
        ? location.state.cartItems
        : null;

    // 2) fallback to existing shared cart
    if (!incoming) {
      incoming = Array.isArray(cartItemsArray) && cartItemsArray.length ? cartItemsArray : null;
    }

    if (!Array.isArray(incoming) || incoming.length === 0) return;

    const normalizedIncoming = normalizeCartItems(incoming);
    if (!normalizedIncoming.length) return;

    // Update form items
    onFormUpdate(normalizedIncoming);

    // Ensure shared cart matches incoming (only if different)
    const incomingKey = itemsKey(normalizedIncoming);
    if (incomingKey && incomingKey !== cartItemsKey) {
      cartReplace?.(normalizedIncoming);
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
    setCartPrefillHandled(true);
  }, [
    loading,
    cartPrefillHandled,
    companyId,
    myId,
    location.search,
    location.state,
    selectedRequest,
    cartItemsArray,
    cartItemsKey,
    cartReplace,
    onFormUpdate,
  ]);

  return { cartPrefillHandled };
};